import {
	VIEWDOCUMENTS_SEARCH_ERROR,
	VIEWDOCUMENTS_FIND_DOCUMENTS,
	VIEWDOCUMENTS_SAVED_INDIVIDUAL_BUILD_CONCEPTS_LOADED_SUCCESS,
	VIEWDOCUMENTS_SEARCHING,
	VIEWDOCUMENTS__NEED_TO_REFESH_DOCUMENTS,
	VIEWDOCUMENTS_SET_SOURCE_FILTER,
	VIEWDOCUMENTS_LOAD_CURRENT_TERMS,
	VIEWDOCUMENTS_UPDATE_DOCUMENT_PRIORITY,
	GET_ALL_DOCUMENTS_REQUEST,
	GET_ALL_DOCUMENTS_REQUEST_SUCCESS,
	GET_ALL_DOCUMENTS_REQUEST_FAILED,
	GET_ALL_DOCUMENTS_REQUEST_FAILED_CLEAR,
	GET_DOCUMENTS_REQUEST,
	GET_DOCUMENTS_REQUEST_SUCCESS,
	GET_DOCUMENTS_REQUEST_FAILED,
	GET_DOCUMENTS_REQUEST_FAILED_CLEAR,
	GET_ALL_DOCUMENTS_IN_BACKGROUND_REQUEST,
	GET_ALL_DOCUMENTS_IN_BACKGROUND_REQUEST_SUCCESS,
	GET_ALL_DOCUMENTS_IN_BACKGROUND_REQUEST_FAILED,
	GET_ALL_DOCUMENTS_IN_BACKGROUND_REQUEST_FAILED_CLEAR,
	UPDATE_METADATA,
	UPDATE_VIEWDOCUMENTS_METADATA,
	SET_EXPAND_GRAPH,
} from "../types"

//cada reducer tiene su propio state
const initialState = {
	concept_docs: {
		count: 0,
		data: {},
	},
	loading: false,
	error: false,
	concept_terms: {
		targetTerms: [],
		ignoreTerms: [],
		includeSpecificTerms: [],
		ignoreSpecificTerms: [],
	},
	sourceFilter: {
		doc: true,
		xls: true,
		ppt: true,
		pdf: true,
		txt: true,
		email: true,
		fromDate: "",
		toDate: "",
	},
	currentConceptTargetTerms: [],
	allDocuments: {
		count: 0,
		data: {},
	},
	allDocumentsCount: 0,
	allDocumentsLoading: false,
	documentLoading: false,
	document: {},
	allDocumentsLoadingInBackground: false,
	expandGraph: false,
}
// eslint-disable-next-line
export default function (state = initialState, action) {
	switch (action.type) {
		case VIEWDOCUMENTS_UPDATE_DOCUMENT_PRIORITY:
			try {
				if (state.concept_docs.count > 0) {
					let index = state.concept_docs.data.findIndex((data) => data.id === action.payload.id)
					let aux_concept_docs = state.concept_docs
					aux_concept_docs.data[index]["tags"] = action.payload.priority
					return {
						...state,
						concept_docs: aux_concept_docs,
					}
				}
			} catch (error) {
				return { ...state }
			}
		case VIEWDOCUMENTS_LOAD_CURRENT_TERMS:
			return { ...state, currentConceptTargetTerms: action.payload }

		case VIEWDOCUMENTS_SET_SOURCE_FILTER:
			return { ...state, sourceFilter: action.payload }

		case VIEWDOCUMENTS_SAVED_INDIVIDUAL_BUILD_CONCEPTS_LOADED_SUCCESS:
			let newConcepts = {
				targetTerms: action.payload.terms,
				ignoreTerms: action.payload.ignore,
				includeSpecificTerms: action.payload.soft_include === null ? [] : action.payload.soft_include,
				ignoreSpecificTerms: action.payload.soft_ignore,
			}
			return {
				...state,
				concept_terms: newConcepts,
				loading: false,
			}

		case VIEWDOCUMENTS_SEARCHING:
			return {
				...state,
				loading: action.payload,
			}
		case VIEWDOCUMENTS_SEARCH_ERROR:
			return {
				...state,
				loading: false,
				error: action.payload,
			}
		case VIEWDOCUMENTS_FIND_DOCUMENTS:
			return {
				...state,
				loading: false, // Se ha añadido este loading: false, para que desaparezca una vez se carguen los elementos.
				concept_docs: action.payload,
			}
		case UPDATE_VIEWDOCUMENTS_METADATA:
			const payloadMeta = action.payload
			const currentMetaData = { ...state.concept_docs }
			const iIndex = Array.isArray(currentMetaData.data) ? currentMetaData.data.findIndex((data) => data.id === payloadMeta.id) : -1 //find the id
			if (iIndex !== -1) {
				let updateMetaRecord = currentMetaData.data[iIndex] //get the object
				updateMetaRecord = { ...updateMetaRecord, ...payloadMeta.data } //update the object
				currentMetaData.data[iIndex] = updateMetaRecord //assign bakc to list
			}
			return {
				...state,
				concept_docs: currentMetaData,
			}
		case GET_ALL_DOCUMENTS_REQUEST:
			return {
				...state,
				allDocumentsLoading: true,
			}
		case GET_ALL_DOCUMENTS_REQUEST_SUCCESS:
			return {
				...state,
				allDocumentsLoading: false,
				allDocuments: action.payload.data || [],
				allDocumentsCount: action.payload?.count || 0,
			}
		case GET_ALL_DOCUMENTS_REQUEST_FAILED:
			return {
				...state,
				allDocumentsLoading: false,
				allDocumentsError: action.payload,
			}
		case GET_ALL_DOCUMENTS_REQUEST_FAILED_CLEAR:
			return {
				...state,
				allDocumentsError: undefined,
			}

		case GET_ALL_DOCUMENTS_IN_BACKGROUND_REQUEST:
			return {
				...state,
				allDocumentsLoadingInBackground: true,
			}
		case GET_ALL_DOCUMENTS_IN_BACKGROUND_REQUEST_SUCCESS:
			return {
				...state,
				allDocumentsLoadingInBackground: false,
				allDocuments: action.payload.data || [],
				allDocumentsCount: action.payload?.count || 0,
			}
		case GET_ALL_DOCUMENTS_IN_BACKGROUND_REQUEST_FAILED:
			return {
				...state,
				allDocumentsLoadingInBackground: false,
				allDocumentsBackgroundError: action.payload,
			}
		case GET_ALL_DOCUMENTS_IN_BACKGROUND_REQUEST_FAILED_CLEAR:
			return {
				...state,
				allDocumentsBackgroundError: undefined,
			}

		case UPDATE_METADATA:
			const payload = action.payload
			const currentData = { ...state.allDocuments }
			const index = currentData.data.findIndex((data) => data.id === payload.id) //find the id
			let updateRecord = currentData.data[index] //get the object
			updateRecord = { ...updateRecord, ...payload.data } //update the object
			currentData.data[index] = updateRecord //assign bakc to list

			return {
				...state,
				allDocuments: currentData,
			}

		case GET_DOCUMENTS_REQUEST:
			return {
				...state,
				documentLoading: true,
				document: {},
			}
		case GET_DOCUMENTS_REQUEST_SUCCESS:
			return {
				...state,
				documentLoading: false,
				document: action.payload || {},
			}
		case GET_DOCUMENTS_REQUEST_FAILED:
			return {
				...state,
				documentLoading: false,
				documentError: action.payload,
			}
		case GET_DOCUMENTS_REQUEST_FAILED_CLEAR:
			return {
				...state,
				documentError: undefined,
			}
		case SET_EXPAND_GRAPH:
			return {
				...state,
				expandGraph: action.payload,
			}
		default:
			return state
	}
}
